/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import Button from '../button';
import { BackButtonProps } from './types';
import { generateID } from '../../base/helper';

const BackButton = ({
  text,
  icon,
  type,
  size,
  onClick,
  id = generateID('clientos-ui-toolkit-drawer-back-button'),
  ...rest
}: BackButtonProps) => {
  return (
    <div className="clientos-ui-toolkit-drawer__back-button">
      <Button
        type={type}
        onClick={onClick}
        icon={icon}
        size={size}
        id={id}
        {...rest}
      >
        {text}
      </Button>
    </div>
  );
};

export default memo(BackButton);
